// FAQ content for /faq. `links` render as action links under the answer.
const faqCategories = [
  { key: "getting-started", label: "Getting started" },
  { key: "pricing", label: "Pricing & payment" },
  { key: "delivery", label: "Delivery & tracking" },
  { key: "items", label: "Items & insurance" },
  { key: "business", label: "Business" },
  { key: "drivers", label: "Drivers" },
];

const faqs = [
  {
    id: "how-it-works",
    category: "getting-started",
    question: "How does Parcelin work?",
    answer:
      "Parcelin connects your parcel with a driver who is already travelling your route. Choose your pickup and delivery locations and parcel size, book and pay online, and a verified driver collects it on your collection date. It's like carpooling, but for packages.",
    links: [{ href: "/how-it-works", label: "See the five steps" }],
  },
  {
    id: "service-areas",
    category: "getting-started",
    question: "Which areas do you deliver to?",
    answer:
      "In Limpopo we deliver to Polokwane, Giyani, Malamulele, Tzaneen, Bungeni, Thohoyandou and Phalaborwa. In Gauteng we deliver within 70km of our Midrand warehouse. We're working on adding more areas across South Africa.",
  },
  {
    id: "account-needed",
    category: "getting-started",
    question: "Do I need an account to get a quote?",
    answer:
      "No. You can get an instant quote without signing up. When you're ready to book, you log in or sign up with your cellphone number and a one-time PIN.",
    links: [{ href: "/", label: "Get a quote" }],
  },
  {
    id: "cost",
    category: "pricing",
    question: "How much does delivery cost?",
    answer:
      "The price depends on the route, the parcel size and the delivery speed you choose, with same-day and next-day options. You always see the exact price before you book.",
    links: [{ href: "/", label: "Get an instant quote" }],
  },
  {
    id: "payment-methods",
    category: "pricing",
    question: "How can I pay?",
    answer:
      "You pay online through PayFast when you book. We also accept mobile payments including e-Wallet, Money Send, PayShap and Capitec transfers.",
  },
  {
    id: "wallet-credit",
    category: "pricing",
    question: "How do referral rewards work?",
    answer:
      "Share your referral link from your profile. When someone you refer places their first paid order, you earn R50 in wallet credit, which is taken off your next order automatically.",
    links: [{ href: "/profile", label: "Find your referral link" }],
  },
  {
    id: "tracking-number",
    category: "delivery",
    question: "How do I track my parcel?",
    answer:
      "Your 8-digit tracking number is in your order confirmation email. Enter it on the tracking page to see the latest status, or find all your orders under My Parcels when you're logged in.",
    links: [{ href: "/track-parcel", label: "Track a parcel" }],
  },
  {
    id: "receiver-updates",
    category: "delivery",
    question: "Will the receiver be told when the parcel is coming?",
    answer:
      "Yes. The receiver gets a WhatsApp message (or an SMS) when the parcel is out for delivery and again when it has been delivered, with a link to track it.",
  },
  {
    id: "pickup-time",
    category: "delivery",
    question: "Can I choose when my parcel is collected?",
    answer:
      "Yes. You choose your collection date when you book, and the driver will coordinate a specific pickup time with you.",
  },
  {
    id: "collection-points",
    category: "delivery",
    question: "What does \"Ready for collection\" mean?",
    answer:
      "Some Limpopo deliveries go to a collection point. \"Ready for collection\" means the parcel has arrived there and is waiting for the receiver to collect it.",
  },
  {
    id: "cancel-or-change",
    category: "delivery",
    question: "Can I cancel or change my booking?",
    answer:
      "Contact us before your parcel is collected and we'll help you cancel or change it. Cancellation fees may apply depending on how close to the pickup you cancel.",
    links: [{ href: "/contact", label: "Contact us" }],
  },
  {
    id: "allowed-items",
    category: "items",
    question: "What can I send?",
    answer:
      "You can send most non-hazardous items, including documents, clothing, electronics and personal items. Illegal substances, weapons, explosives and hazardous materials are not allowed.",
  },
  {
    id: "insurance",
    category: "items",
    question: "Is my parcel insured?",
    answer:
      "Yes, all parcels are covered by our basic insurance. If you're sending something of high value, contact us before you book.",
  },
  {
    id: "damaged-or-lost",
    category: "items",
    question: "What if my parcel is damaged or lost?",
    answer:
      "Contact our support team straight away with your tracking number. We'll work quickly to resolve it and help with any claim.",
    links: [{ href: "/contact", label: "Contact support" }],
  },
  {
    id: "business-account",
    category: "business",
    question: "Do you offer business accounts?",
    answer:
      "Yes. A business account gives you a dashboard for all your orders, bulk uploads for many parcels at once, and a choice of paying per order, monthly invoicing or prepaid.",
    links: [{ href: "/signup", label: "Open a business account" }],
  },
  {
    id: "integrations",
    category: "business",
    question: "Can I connect my online store?",
    answer:
      "Yes. Parcelin integrates with Shopify and WooCommerce, and our API lets you create orders, track them and download waybills from your own systems.",
    links: [{ href: "/developers", label: "Read the API docs" }],
  },
  {
    id: "become-driver",
    category: "drivers",
    question: "How do I become a Parcelin driver?",
    answer:
      "If you regularly travel between our service areas, get in touch to apply. You'll need a valid driver's licence, your vehicle registration, and to pass our verification process.",
    links: [{ href: "/contact", label: "Apply via Contact Us" }],
  },
  {
    id: "eco-friendly",
    category: "drivers",
    question: "How is Parcelin environmentally friendly?",
    answer:
      "We use vehicles that are already on the road instead of adding more cars. That means fewer emissions and less traffic for every parcel delivered.",
  },
];

export { faqCategories, faqs };
